import { ref } from "vue"

const visible = ref(false)

export function useAppointmentForm() {
	function open() {
		visible.value = true
	}

	return {
		visible,
		open
	}
}
